import { useState } from 'react';

import { Dropdown, DropdownItem } from '../Dropdown/Dropdown';
import { SwitcherModal } from '../SwitcherModal';
import { OpCoListContent, useRequiredContent } from '../services/content';
import { useSafeCookies } from '../../hooks/useCookies/useSafeCookies';
import { pushGTMEvent } from '../../utilities';
import { HEADER } from '../../consts';
import { useHeaderProps } from '../../contexts/headerProps';

export interface OpCoSelectorProps {
  hidePickedLabel?: boolean;
}

export const OpCoSelector = ({ hidePickedLabel }: OpCoSelectorProps) => {
  const { auth, userDetails } = useHeaderProps();
  const [isOpen, setIsOpen] = useState(false);
  const [opCoId, setOpCoId] = useState<string>();
  const { data: opcos } = useRequiredContent(OpCoListContent);
  const { opco, setOpco } = useSafeCookies();

  const options: Array<DropdownItem> = opcos.map((opco) => ({ id: opco.id, image: opco.image, label: opco.label }));

  return (
    <>
      <div data-testid="opCo-selector">
        <Dropdown
          options={options}
          value={opco}
          onChange={(id) => {
            if (userDetails) {
              setOpCoId(id);
              setIsOpen(!isOpen);
            } else {
              setOpco(id);
            }
            pushGTMEvent(HEADER, `opco switcher - ${id.toLowerCase()}`);
          }}
          hidePickedLabel={hidePickedLabel}
        />
      </div>
      <SwitcherModal
        targetOpCoId={opCoId}
        auth={auth}
        isOpen={isOpen}
        onClose={() => setIsOpen(!isOpen)}
        onPressCta={() => {
          if (opCoId) {
            auth?.logoutProps.onClick?.(opCoId);
            setOpco(opCoId);
          }
        }}
      />
    </>
  );
};
